export const eventNames = {
  5: "Last Puck Overtake",
  50: "Gets a Hanger",
  51: "Gets a High Five",
  100: "Gets a Short Circuit",
  155: "Gets a Territory Big Swing",
  200: "Gets a Total Eclipse",
  400: "Gets a Studio 21 checkout",
  450: "Joins the 111 club",
};
